import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { TableModule } from 'primeng/table';
import * as bootstrap from 'bootstrap';
import { MessageService } from 'primeng/api';
import { user_privilege } from '../../../../_model/user_privilege';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { FormBuilder, FormsModule } from '@angular/forms';

import {
  DatePipe,
  JsonPipe,
  NgClass,
  NgFor,
  NgIf,
  NgStyle,
} from '@angular/common';
import { HighlightDirective } from '../../../_directives/highlight.directive';
import { ActivatedRoute, Router } from '@angular/router';
import { BusyService } from '../../../_services/busy.service';
import { ExportDataService } from '../../../_services/export-data.service';
import { GlobalService } from '../../../_services/global.service';
import { ConstantService } from '../../../_services/constant.service';
import { AuthenticationService } from '../../../_services/authentication.service';
import { DatasearchService } from '../../../_services/datasearch.service';
import { CommanService } from '../../../_services/comman.service';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-cipac',
  standalone: true,
  imports: [
    TableModule,
    CommonModule,
    CalendarModule,
    TooltipModule,
    NgIf,
    NgFor,
    NgClass,
    NgStyle,
    FormsModule,
    HighlightDirective,
    DropdownModule,
  ],
  templateUrl: './cipac.component.html',
  styleUrl: './cipac.component.scss',
})
export class CipacComponent {
  isFullScreen: boolean = false;
  totalRecords: any;
  isListView: boolean = true;
  productDetails: boolean = false;
  cols: any[] = [];
  products_current_datasource: any[] = [];
  rows: number = 50;
  countries: any[] = [];
  cropCommodities: any[] = [];
  selectedCountry: string = 'View All';
  selectedCrop: string = 'View All';
  loading_table = false;
  TableRowsCounts: number[] = [5, 10, 20, 25, 50, 100, 150];
  tablefilter: any = {};
  patentTypes: any[] = [];
  mrlTableFliters!: any;
  dateValue: any = {};
  searchedWords: string[] = [];
  rptDataForExcel: any = [];
  searchQueryGrid: string = '';
  current_GBRN: any = 0;
  filterAppliedWithNoResults = false;
  oldSearchQueryGrid = '';
  serialStart: number = 0;
  privilege_json!: user_privilege;
  matchModeOptions: any = [
    { label: 'Select Filter', value: 'select' },
    { label: 'Date is', value: 'dateIs' },
    { label: 'Date is not', value: 'dateIsNot' },
    { label: 'Date is before', value: 'dateBefore' },
    { label: 'Date is after', value: 'dateAfter' },
  ];
  detailViewTabs = [
    { header: 'BIBLIOGRAPHY', field: '' },
    { header: 'description', field: 'description' },
    { header: 'CLAIMS', field: 'claims' },
    { header: 'PATENT FAMILY', field: 'patent_familf' },
    { header: 'SPC', field: 'spc' },
    { header: 'ORANGE BOOK (OB) PATENTS', field: 'dummy2' },
  ];
  isShowReadMoreDialog: boolean = false;
  readMoreColumn: string = '';
  readMoreContent: string = '';
  detailViewData: any = {};
  updatePrivilege = false;
  oldResult: any = {};
  current_pagenumber: number = 1;
  selectedDetailViewIndex = 0;
  pageLimitInPrivilegeJson: number = 0;
  dynSelectedPatentType: string = '';
  pageLimitInDatabaseLimit: number = 0;
  totalpages: any = 0;
  selectedPage: number = 1;
  searched = true;
  currentFliter: any = {};
  user_data: any;
  first = 0;
  currentSortBy: string = '';
  listSortByfield: string = '';
  listSortOrder: string = 'ASC';
  constructor(
    private messageService: MessageService,
    private datasearch: DatasearchService,
    private authentication: AuthenticationService,
    private _constant: ConstantService,
    private globalService: GlobalService,
    private fb: FormBuilder,
    private exportdataService: ExportDataService,
    private datePipe: DatePipe,
    private busyService: BusyService,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private commanService: CommanService,
    private cdr: ChangeDetectorRef,

    private router: Router
  ) {}
  ngOnInit() {
    this.commanService.productInformationData.subscribe((res: any) => {
      const rawQuery = res.searchQueryGrid || '';
      this.searchQueryGrid = this.parseSearchQuery(rawQuery); // <-- returns a string
    });
    this.commanService.getUserPrivilege().subscribe((res: any) => {
      this.privilege_json = res || {};
    });
    this.authentication.getCurrentUserValue().subscribe((val: any) => {
      this.user_data = val;
    });
    this.commanService.currentgbrn.subscribe((gbrn_res: any) => {
      if (gbrn_res) {
        this.current_GBRN = gbrn_res;
        this.search_data();
      }
    });

    this.loadColumnDetails();
    // this.getUserPrivilege();
    this.datasearch
      .GetDatabasePageLimit({
        database: 'AgroPat Ultimate Discovery Suite Beta',
      })
      .subscribe(
        (res: any) => {
          if (res.status) {
            this.pageLimitInDatabaseLimit = res.data.page_limit
              ? Number(res.data.page_limit)
              : 0;
          } else {
            console.log('Error: API response success is false', res);
          }
        },
        (error: any) => {
          console.log('Error fetching database page limit:', error);
        }
      );
  }
  // async getUserPrivilege(): Promise<void> {
  //   this.authentication.getCurrentUserValue().subscribe((val: any) => {
  //     console.log('[getUserPrivilege] - Current user data received:', val);

  //     this.user_data = val;

  //     // ✅ Get stored privileges from localStorage
  //     const storedPrivileges = JSON.parse(
  //       localStorage.getItem('user_privilege') || '{}'
  //     );

  //     if (!storedPrivileges || Object.keys(storedPrivileges).length === 0) {
  //       console.warn(
  //         '[getUserPrivilege] - No user_privilege found in localStorage.'
  //       );
  //       return;
  //     }

  //     // ✅ App key for agropat privilege
  //     const appKey = 'agropat-ultimate-discovery-suite-beta';
  //     const privilegeData = storedPrivileges[appKey];

  //     if (!privilegeData) {
  //       console.warn(
  //         `[getUserPrivilege] - No privilege found for app: ${appKey}`
  //       );
  //       return;
  //     }

  //     console.log(
  //       `[getUserPrivilege] - Fetched privilege data for ${appKey}:`,
  //       privilegeData
  //     );

  //     // ✅ Store locally for this component
  //     this.privilege_json = privilegeData;

  //     // ✅ Push privilege data to CommanService (Reactive access)
  //     this.commanService.currentPrivilege.next(this.privilege_json);

  //     console.log(
  //       `[getUserPrivilege] - Privilege JSON pushed to commanService for ${appKey}.`
  //     );
  //   });
  // }

  search_data(isFilterApplied = false) {
    if (isFilterApplied) {
      this.selectedPage = 1;
      this.first = 0;
      this.commanService.currentPrivilege.next(1);
    }

    const postdata = {
      gbrn: this.current_GBRN || '',
      filters:
        this.mrlTableFliters && Object.keys(this.mrlTableFliters).length > 0
          ? this.mrlTableFliters
          : {},
      pagenumber: this.current_pagenumber,
      limit: this.rows || 15,
      sortby: this.currentSortBy || 'title ASC',
    };

    this.busyService.busy();
    this.searched = false;
    this.products_current_datasource = [];

    this.datasearch.getplatformcipacdata(postdata).subscribe({
      next: (res: any) => {
        this.products_current_datasource = res?.data.data || [];
        this.totalRecords = res?.data.count || 0;
        this.totalpages = Math.ceil(this.totalRecords / this.rows);

        // recalc offset for pagination
        this.first = (this.selectedPage - 1) * this.rows;

        // renumber S_NO
        this.products_current_datasource.forEach((row, i) => {
          row.S_NO = (this.current_pagenumber - 1) * this.rows + i + 1;
        });
        this.hideColumns();
        this.searched = true;
        this.loading_table = false;
        this.busyService.idle();
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('API Error:', error);
        this.products_current_datasource = [];
        this.totalRecords = 0;
        this.totalpages = 0;
        this.loading_table = false;
        this.busyService.idle();
        this.cdr.detectChanges();
      },
      complete: () => {
        this.searched = true;
        this.loading_table = false;
        this.busyService.idle();
        this.cdr.detectChanges();
      },
    });
  }

  scrollLeft() {
    let element = document.querySelector(
      '#tabledata p-table .p-datatable-wrapper'
    );
    element ? (element.scrollLeft -= 500) : '';
  }
  scrollRight() {
    let element = document.querySelector(
      '#tabledata p-table .p-datatable-wrapper'
    );
    element ? (element.scrollLeft += 500) : '';
  }
  filterClass(col: any) {
    if (this.tablefilter && Object.keys(this.tablefilter).length > 0) {
      if (this.tablefilter[col.tableColumnName]) {
        // Ensure the key exists
        if (col.fieldDataType === 'text') {
          if (
            this.tablefilter[col.tableColumnName]?.matchMode === 'contains' &&
            !this.tablefilter[col.tableColumnName]?.value
          ) {
            return '';
          } else {
            return 'filter-stl';
          }
        } else {
          if (
            this.tablefilter[col.tableColumnName]?.[0]?.matchMode ===
              'contains' &&
            !this.tablefilter[col.tableColumnName]?.[0]?.value
          ) {
            return '';
          } else {
            return 'filter-stl';
          }
        }
      }
    }
    return ''; // Default return if undefined
  }

  filterDate(event: any, field: string) {
    this.dateValue[field] = event;
  }
  addDataSpace(data: any) {
    return data != null ? data.toString().replace(/;/gi, '; ') : data;
  }

  patentClass(patentType: any) {
    let patentArr = patentType.split(' ').filter((patent: any) => {
      return patent.toLowerCase() !== 'patent';
    });

    for (let i = 0; i < patentArr.length; i++) {
      for (let j = 0; j < this.patentTypes.length; j++) {
        if (!patentArr[i]) {
          return '';
        } else if (
          this.patentTypes[j].patentType.search(
            new RegExp(patentArr[i], 'i')
          ) >= 0
        ) {
          return this.patentTypes[j].colour_code;
        }
      }
    }
  }

  getPatentNumber(data: any) {
    let regex_patent = /[A-Z]{2}\d{4,10}/gi;
    if (regex_patent.test(data)) {
      return data.match(regex_patent);
    } else {
      return data;
    }
  }
  showReadMore(column: any, content: any) {
    this.isShowReadMoreDialog = true;
    this.readMoreColumn = column;
    this.readMoreContent = content.replace(/;/gi, '; ');
    this.readMoreContent = this.readMoreContent.replace(/\n|\r\n/gm, '<br/>');
    const modalElement = document.getElementById('read_more_modal');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.show();
      }
    }
  }

  hideReadMore() {
    const modalElement = document.getElementById('read_more_modal');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
  }
  loadProducts(event: any) {
    this.updatePrivilege = false;

    this.oldResult = {
      products_current_datasource: this.products_current_datasource,
      totalRecords: this.totalRecords,
      searchQueryGrid: this.oldSearchQueryGrid,
    };

    this.loading_table = true;

    // ✅ Capture rows per page dynamically
    this.rows = event.rows;

    // ✅ Correctly calculate `pagenumber` for API call
    this.current_pagenumber = Math.floor(event.first / event.rows) + 1;

    // ✅ Ensure user does not exceed page limits
    this.handlePageLimit();
    let maxPagesAllowed =
      this.pageLimitInPrivilegeJson || this.pageLimitInDatabaseLimit;
    if (maxPagesAllowed && this.current_pagenumber > maxPagesAllowed) {
      this.messageService.add({
        severity: 'error',
        detail: `You can only see ${maxPagesAllowed} pages`,
      });
      this.loading_table = false;
      return;
    }

    // ✅ Adjust filters for date values
    if (event.filters) {
      Object.keys(this.dateValue).forEach((dateFilter) => {
        if (event.filters[dateFilter]?.[0]?.matchMode === 'contains') {
          this.dateValue[dateFilter] = null;
        }
        event.filters[dateFilter][0].value = this.dateValue[dateFilter];
      });
    }

    this.tablefilter = event.filters || {}; // ✅ Ensure filters are always defined
    this.first = event.first; // ✅ Store first record index for pagination

    // ✅ Fix Serial Number Calculation
    this.serialStart = this.first + 1;

    // ✅ Handle sorting conditions
    if (event.sortField && this.isListView) {
      this.currentSortBy = `${event.sortField} ${
        event.sortOrder === 1 ? 'ASC' : 'DESC'
      }`;
    } else if (!this.isListView && this.listSortByfield) {
      this.currentSortBy = `${this.listSortByfield} ${this.listSortOrder}`;
    } else {
      this.currentSortBy = '';
    }

    // ✅ Convert filters into Mongo query format
    this.mrlTableFliters = this.convertFiltersToMongoQuery(event.filters);

    // ✅ Fetch updated data with correct pagination
    setTimeout(() => {
      this.search_data();
    });
  }

  convertFiltersToMongoQuery(filters: any): any[] {
    const mongoFilters: any[] = [];

    Object.keys(filters).forEach((field) => {
      const filterValue = filters[field]?.value;
      const matchMode = filters[field]?.matchMode;

      if (filterValue) {
        let mongoCondition: any;

        switch (matchMode) {
          case 'startsWith':
            mongoCondition = { $regex: `^${filterValue}`, $options: 'i' };
            break;
          case 'contains':
            mongoCondition = { $regex: filterValue, $options: 'i' };
            break;
          case 'notContains':
            mongoCondition = { $not: { $regex: filterValue, $options: 'i' } };
            break;
          case 'endsWith':
            mongoCondition = { $regex: `${filterValue}$`, $options: 'i' };
            break;
          case 'equals':
            mongoCondition = filterValue;
            break;
          case 'notEquals':
            mongoCondition = { $ne: filterValue };
            break;
          default:
            return;
        }

        // If filtering on gbrn_products array
        if (field.startsWith('gbrn_products.')) {
          const subField = field.split('.')[1]; // Extract the nested field
          mongoFilters.push({
            gbrn_products: { $elemMatch: { [subField]: mongoCondition } },
          });
        } else {
          mongoFilters.push({ [field]: mongoCondition });
        }
      }
    });

    return mongoFilters;
  }

  handlePageLimit() {
    this.pageLimitInPrivilegeJson = this.privilege_json.PageLimit
      ? +this.privilege_json.PageLimit
      : 0;
  }
  loadColumnDetails() {
    this.datasearch.CIPAC_column_config().subscribe(
      (res: any) => {
        this.cols = (res.data || [])
          .filter((field: any) => field.isDisplay == 1)
          .map((field: any) => ({
            ...field,
            columnWidth: field.columnWidth || '150px', // Fallback if width is missing
          }));
      },
      (error: any) => {
        console.error('Error loading column details:', error);
      }
    );
  }

  applyTableStyles() {
    setTimeout(() => {
      this.cols.forEach((col) => {
        let columnElements = document.querySelectorAll(
          `.col-${col.tableColumnName}`
        );
        columnElements.forEach((el: any) => {
          // Ensure 'px' is appended if col.columnWidth is a number
          el.style.width = col.columnWidth ? `${col.columnWidth}px` : 'auto'; // ✅ Append 'px' if missing
          el.style.backgroundColor = col.columnColor || 'transparent'; // ✅ Apply color dynamically
        });
      });
    }, 500);
  }
  getImageArray(imageData: string | null): string[] {
    return typeof imageData === 'string'
      ? imageData
          .split(';')
          .map((img) => img.trim())
          .filter((img) => img)
      : [];
  }
  getChemicalStructureImages(obj: any, columnName: string): string[] {
    if (obj && obj[columnName] && typeof obj[columnName] === 'string') {
      return obj[columnName]
        .split(';')
        .map((img: string) => img.trim())
        .filter((img: string) => img.length > 0);
    }
    return [];
  }

  resetFilters() {
    this.selectedCountry = 'View All';
    this.selectedCrop = 'View All';
    this.search_data();
  }
  showFullScreen() {
    this.isFullScreen = true;
    const tableElement = this.renderer.selectRootElement('#tabledata', true);
    if (tableElement) {
      this.renderer.addClass(tableElement, 'full-screen-table');
    }
  }
  exitFullScreen() {
    this.isFullScreen = false;
    const tableElement = this.renderer.selectRootElement('#tabledata', true);
    if (tableElement) {
      this.renderer.removeClass(tableElement, 'full-screen-table');
    }
  }

  // Hide columns if columns not have data
  hideColumns() {
    let tempTableData = this.products_current_datasource;
    let tempCols = this.cols;

    this.cols.forEach((currCol) => {
      // For mrl_mongos columns

      let isAllFieldHaveData = tempTableData.every(
        (row) => !row[currCol.tableColumnName]
      );

      // If all field not have data then hide it
      if (isAllFieldHaveData) {
        tempCols.forEach((col) => {
          if (col.tableColumnName === currCol.tableColumnName) {
            col.isDisplay = 0;
          }
        });
      }

      // For basic_product_details_MONGO
      // else {
      //   let hideColumn = false;
      //   tempTableData.forEach((row) => {
      //     let ads_data = row.gbrn_products;

      //     if (ads_data.length) {
      //       let isAllFieldHaveData_ads = ads_data.every(
      //         (obj: any) => !obj[currCol.field]
      //       );
      //       if (isAllFieldHaveData_ads) {
      //         hideColumn = true;
      //       } else {
      //         hideColumn = false;
      //       }
      //     } else {
      //       hideColumn = true;
      //     }
      //   });

      //   if (hideColumn) {
      //     tempCols.forEach((col) => {
      //       if (col.field === currCol.field) {
      //         col.isDisplay = 0;
      //       }
      //     });
      //   }
      // }
    });

    this.cols = tempCols;
    this.cdr;
  }
  goBackToSearch() {
    this.mrlTableFliters = {};

    this.search_data();
  }
  exportExcel(extension: any) {
    // console.log('📥 Export initiated with extension:', extension);
    this.busyService.busy();

    const filters =
      this.mrlTableFliters && Object.keys(this.mrlTableFliters).length > 0
        ? this.mrlTableFliters
        : {};

    const postdata = {
      table_name: 'cipac_mongos',
      gbrn: this.current_GBRN || '',
      filters:
        this.mrlTableFliters && Object.keys(this.mrlTableFliters).length > 0
          ? this.mrlTableFliters
          : {},
      pagenumber: this.current_pagenumber,
      limit: 500,
      sortby: 'title ASC',
    };

    // console.log('📤 Sending post data for export:', postdata);

    this.datasearch.getplatformcipacdata(postdata).subscribe({
      next: (response: any) => {
        let DownloadData = response.data.data || [];
        this.rptDataForExcel = [];

        const cols = this.cols || []; // Use the columns loaded via `loadColumnDetails`
        const displayedColumns = cols
          .filter((col) => Number(col.isDisplay) === 1)
          .sort((a, b) => a.displayOrder - b.displayOrder);

        const fields = displayedColumns.map((col) => col.tableColumnName);
        const headers = displayedColumns.map(
          (col) =>
            col.displayColumnName || col.excelColumnName || col.tableColumnName
        );

        const nonEmptyFields = fields.filter((field) => {
          return DownloadData.some((row: any) => {
            if (row.gbrn_products?.length > 0) {
              return row.gbrn_products.some(
                (prod: any) =>
                  prod[field] !== null &&
                  prod[field] !== undefined &&
                  prod[field] !== ''
              );
            }
            return (
              row[field] !== null &&
              row[field] !== undefined &&
              row[field] !== ''
            );
          });
        });

        const filteredHeaders = displayedColumns
          .filter((col) => nonEmptyFields.includes(col.tableColumnName))
          .map(
            (col) =>
              col.displayColumnName ||
              col.excelColumnName ||
              col.tableColumnName
          );

        const filteredDataRows = DownloadData.filter((row: any) => {
          return nonEmptyFields.some((field) => {
            if (row.gbrn_products?.length > 0) {
              return row.gbrn_products.some(
                (prod: any) =>
                  prod[field] !== null &&
                  prod[field] !== undefined &&
                  prod[field] !== ''
              );
            }
            return (
              row[field] !== null &&
              row[field] !== undefined &&
              row[field] !== ''
            );
          });
        });

        filteredDataRows.forEach((row: any, index: number) => {
          row.S_NO = index + 1;
          const rowData = nonEmptyFields.map((field) => {
            if (row.gbrn_products?.length > 0) {
              const gbrnProduct = row.gbrn_products[0];
              if (gbrnProduct.hasOwnProperty(field)) {
                return gbrnProduct[field];
              }
            }
            return row[field];
          });
          this.rptDataForExcel.push(rowData);
        });

        const reportData = {
          title: ' CIPAC Data Report',
          data: this.rptDataForExcel,
          headers: filteredHeaders,
          sheetname: 'data',
          file_extention: extension,
          searchterm: this.searchQueryGrid,
        };

        // console.log('📁 Exporting with:', reportData);
        this.exportdataService.exportExcel(reportData);
      },

      error: (error: any) => {
        console.error('❌ Export error:', error);
        this.busyService.idle();
      },
      complete: () => {
        // console.log('✅ Export completed.');
        this.busyService.idle();
      },
    });
  }
  parseSearchQuery(query: string): string {
    const regex = /ACTIVE\s*INGREDIENT:\s*\(([^)]+)\)/gi;
    let matches: string[] = [];
    let match;

    while ((match = regex.exec(query)) !== null) {
      matches.push(match[1].toUpperCase()); // Convert each to uppercase
    }

    // Replace original condition logic (AND/OR/etc.) in the query
    let result = query;

    // Replace with placeholders to capture order
    let placeholderIndex = 0;
    result = result.replace(regex, () => `{{${placeholderIndex++}}}`);

    // Replace placeholders with capitalized matches
    matches.forEach((val, i) => {
      result = result.replace(`{{${i}}}`, val);
    });

    return result;
  }
}
